// Bridge Horizon's asynchronous variant rendering to the existing Klaviyo notification form.
(() => {
  const configuration = document.getElementById('sa-klaviyo-back-in-stock-config');

  if (!configuration || window.saKlaviyoBackInStockInitialised || !window.klaviyo?.init) return;

  const settings = JSON.parse(configuration.textContent);
  window.klaviyo.init(settings.init);
  window.klaviyo.enable('backinstock', settings.options);
  window.saKlaviyoBackInStockInitialised = true;

  // The SDK listens for change events. Horizon updates the hidden ID after its section fetch.
  for (const form of document.querySelectorAll('product-form-component')) {
    let lastVariantId = form.querySelector('input[name="id"]')?.value;
    const observer = new MutationObserver(() => {
      const input = form.querySelector('input[name="id"]');

      if (!input || input.value === lastVariantId) return;

      lastVariantId = input.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    observer.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'value'] });
  }
})();
